import { jwtDecode, JwtPayload } from "jwt-decode";

interface ExtendedJwtPayload extends JwtPayload {
  authorities?: string[];
}

export const decodeJwt = (token: string): ExtendedJwtPayload | null => {
  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch {
    return null;
  }
};
